import { useState } from "react";
import { signup } from "./AuthService";
import { useNavigate } from "react-router-dom";
import "./Signup.css";

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
const PHONE_REGEX = /^\+?[0-9]{10,15}$/;

export default function Signup(){

  const nav = useNavigate();
  const [form,setForm] = useState({
    firstName:"",
    lastName:"",
    username:"",
    email:[],
    phoneNos:[],
    password:""
  });
  const [errors, setErrors] = useState({
    email: "",
    phoneNos: "",
  });

  const normalizePhone = (value = "") => value.replace(/[\s()-]/g, "");

  const validateForm = () => {
    const nextErrors = { email: "", phoneNos: "" };
    const emailValue = (form.email?.[0] || "").trim();
    const phoneRawValue = (form.phoneNos?.[0] || "").trim();
    const phoneValue = normalizePhone(phoneRawValue);

    if (!EMAIL_REGEX.test(emailValue)) {
      nextErrors.email = "Enter a valid email address.";
    }

    if (phoneValue && !PHONE_REGEX.test(phoneValue)) {
      nextErrors.phoneNos = "Enter a valid phone number (10-15 digits).";
    }

    setErrors(nextErrors);
    return !nextErrors.email && !nextErrors.phoneNos;
  };

  const submit = async (e)=>{
    e.preventDefault();
    if (!validateForm()) return;

    const phoneValue = normalizePhone((form.phoneNos?.[0] || "").trim());

    await signup({
      ...form,
      email: [(form.email?.[0] || "").trim()],
      phoneNos: phoneValue ? [phoneValue] : [],
    });
    nav("/login");
  };

  return (
    <div className="signup-page">
      <div className="card signup-card">

        <div className="signup-card-header">
          <h2>Create Account</h2>
          <p className="signup-subtitle">Start managing your finances</p>
        </div>

        <form onSubmit={submit} className="form-grid">

          <input className="input" placeholder="First Name"
            onChange={e=>setForm({...form,firstName:e.target.value})} required />

          <input className="input" placeholder="Last Name"
            onChange={e=>setForm({...form,lastName:e.target.value})} required />

          <input className="input form-full" placeholder="Username"
            onChange={e=>setForm({...form,username:e.target.value})} required />

          <div>
            <input
              className={`input ${errors.email ? "signup-input-error" : ""}`}
              type="email"
              placeholder="Email"
              onChange={e => {
                setForm({...form,email:[e.target.value]});
                if (errors.email) setErrors({ ...errors, email: "" });
              }}
              required
            />
            {errors.email && <div className="signup-error">{errors.email}</div>}
          </div>

          <div>
            <input
              className={`input ${errors.phoneNos ? "signup-input-error" : ""}`}
              type="tel"
              placeholder="Phone"
              onChange={e => {
                setForm({...form,phoneNos:[e.target.value]});
                if (errors.phoneNos) setErrors({ ...errors, phoneNos: "" });
              }}
            />
            {errors.phoneNos && <div className="signup-error">{errors.phoneNos}</div>}
          </div>

          <input className="input form-full" type="password" placeholder="Password"
            onChange={e=>setForm({...form,password:e.target.value})} required />

          <div className="form-full signup-submit-wrap">
            <button className="btn btn-primary" type="submit">
              Create Account
            </button>
          </div>
        </form>

        <div className="signup-footer">
          Already have an account?{" "}
          <span
            className="signup-link"
            onClick={()=>nav("/login")}
          >
            Login
          </span>
        </div>

      </div>
    </div>
  );
}
